import {getScrollbarContainer, isScrollbarEnabled} from './scrollbar';

// on survey validation problem scroll directly to the first element with a problem
export default function () {
    $(window).on('load', function () {
        const $problematicElement = $('.is-problem:first');
        if ($problematicElement.length) {
            const $scrollContainer = isScrollbarEnabled() ? getScrollbarContainer() : $('html, body');
            const topOffset = isScrollbarEnabled() ? $scrollContainer.scrollTop() - $scrollContainer.offset().top : 0;
            // subtract the navigation bar height
            let scrollTop = $problematicElement.closest('.survey-item').offset().top - $('nav.navbar').height();
            const $parentSlider = $problematicElement.parents('.slider');
            if ($parentSlider.length) {
                // if the problem happens for a slider input subtract also the height of the fixed slider option container
                scrollTop -= $('.floating-header', $parentSlider).height();
            }
            $scrollContainer.animate({
                scrollTop: scrollTop + topOffset
            }, 1000);
        }
    });
}